/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from './ErrorBoundary';
import OverlayView from './OverlayView';
/**
 * The Overlay component
 */
class Overlay extends Component {
	render() {
		const {
			logger,
			content,
			dashboard,
			overlayModel,
			overlayParentNode
		} = this.props;
		return (
			<ErrorBoundary
				logger={logger}
			>
				<OverlayView
					content={content}
					dashboard={dashboard}
					overlayModel={overlayModel}
					overlayParentNode={overlayParentNode}
				/>
			</ErrorBoundary>
		);
	}
}

Overlay.propTypes = {
	logger: PropTypes.object.isRequired,
	content: PropTypes.object.isRequired,
	dashboard: PropTypes.object.isRequired,
	overlayModel: PropTypes.object.isRequired,
	overlayParentNode: PropTypes.object.isRequired
};

export default Overlay;



// WEBPACK FOOTER //
// ./src/js/Overlay.js